import { useRootStore } from 'contexts/RootStore.context';
import { colours } from 'styling/colours';
import { User } from 'types/userInfo';
import { assetEstimateIsNotFresh, getValueSafely } from 'utils/utils';

const LocationCellRecentUser = ({ user }: { user: User }) => {
  const { freshPeriodThresholdSeconds } = useRootStore()

  if (user !== undefined && user.location) {
    const assetIsOutdoor = user.location?.is_outdoors;

    let showError = false;
    if (assetEstimateIsNotFresh(user.last_update_timestamp, freshPeriodThresholdSeconds)) {
      showError = true;
    }

    return (
      <div
        className="u-no-pointer-event"
        data-tag="allowRowEvents"
        style={{
          color: showError ? `${colours.error}` : ``,
        }}
      >
        <div>
          {assetIsOutdoor ? (
            <div>Outside Mapped Buildings</div>
          ) : (
            <div>
              <div data-test-id="floor-name">
                {getValueSafely(user.location?.building_level?.level.name)}/
                {getValueSafely(user.location?.building_level?.possible_buildings[0].name)}
              </div>
              <div data-test-id="region-name">{getValueSafely(user.location?.region?.name)}</div>
            </div>
          )}
        </div>
      </div>
    );
  }
  return <>––</>;
};
export default LocationCellRecentUser;
